<template>
    <div class="viewer-wrapper">
        <!-- Khung hiển thị file -->
        <iframe
            v-if="viewerUrl && !usePdfJsViewer"
            :src="viewerUrl"
            frameborder="0"
            class="file-viewer"
            @error="onViewerError"
            @load="onViewerLoad"
            ref="iframeViewer"
        ></iframe>
        <PDFViewer
            v-else-if="fileExt === '.pdf'.toLowerCase() && usePdfJsViewer"
            :src="fileUrl"
            class="file-viewer"
        />
        <div v-else class="loading-message">
            Đang tải tệp tin...
        </div>

        <!-- Footer thông tin file -->
        <div class="file-info">
            <div class="info-text" style="flex-direction: row; align-items: center;">
                <img src="/DTHU.png" alt="Avatar" class="file-avatar" />
                <div style="margin-left: 10px;">
                    <div class="file-name">{{ fileName || "Đang tải..." }}</div>
                    <div class="file-meta">
                        <span> {{ fileDate }}</span>
                        <span v-if="formattedSize"> - {{ formattedSize }}</span>
                    </div>
                </div>
            </div>
            <button v-if="fileUrl" class="download-btn" @click="downloadFile" title="Tải xuống">
                ⬇️
            </button>
        </div>
    </div>
</template>

<script>
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer'
export default {
    name: "XemTepTin",
    components: { PDFViewer },
    data() {
        return {
            apiUrl: process.env.VUE_APP_API_URL,
            fileUrl: null,
            fileName: "",
            fileExt: "",
            fileSize: 0,
            fileDate: "",
            usePdfJsViewer: false,
            iframeLoaded: false
        };
    },
    computed: {
        viewerUrl() {
            if (!this.fileUrl || !this.fileExt) return null;
            return this.fileExt === ".pdf"
                ? `https://drive.google.com/viewerng/viewer?url=${encodeURIComponent(this.fileUrl)}&embedded=true`
                : `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(this.fileUrl)}`;
        },
        formattedSize() {
            if (!this.fileSize) return "";
            const units = ["B", "KB", "MB", "GB"];
            let size = this.fileSize;
            let unitIndex = 0;
            while (size >= 1024 && unitIndex < units.length - 1) {
                size /= 1024;
                unitIndex++;
            }
            return size.toFixed(2) + " " + units[unitIndex];
        }
    },
    async created() {
        const fileId = this.$route.params.id;
        this.fileUrl = this.apiUrl + "files/view-mobile/" + fileId;
        try {
            const res = await fetch(this.apiUrl + "files/get-by-id/" + fileId);
            if (res.ok) {
                const json = await res.json();
                if (json.resultCode === "SUCCESS" && json.data) {
                    this.fileName = json.data.name || "";
                    this.fileExt = (json.data.ext || "").toLowerCase();
                    this.fileSize = json.data.size || 0;
                    this.fileDate = json.data.date || "";
                }
            }
        } catch (err) {
            console.error("Lỗi khi gọi API:", err);
        }
    },
    mounted() {
        // Nếu sau 3s iframe chưa load thì fallback sang PDF JS
        if (this.fileExt === '.pdf') {
            setTimeout(() => {
                if (!this.iframeLoaded) {
                    this.usePdfJsViewer = true;
                }
            }, 3000);
        }
    },
    methods: {
        onViewerError() {
            this.usePdfJsViewer = true;
        },
        onViewerLoad() {
            this.iframeLoaded = true;
        },
        downloadFile() {
            if (!this.fileUrl) return;
            // Lấy thời gian hiện tại theo định dạng yyyymmddHHMMss
            const now = new Date();
            const pad = n => n.toString().padStart(2, '0');
            const dateStr =
                now.getFullYear().toString() +
                pad(now.getMonth() + 1) +
                pad(now.getDate()) +
                pad(now.getHours()) +
                pad(now.getMinutes()) +
                pad(now.getSeconds());
            // Thêm tiền tố ngày giờ vào tên file
            const name = this.fileName ? `${dateStr}_${this.fileName}` : `${dateStr}_file`;
            const link = document.createElement("a");
            link.href = this.fileUrl;
            link.download = name;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
};
</script>

<style scoped>
.viewer-wrapper {
    height: 100vh;
    background: #f9f9f9;
}

.file-viewer {
    width: 100%;
    height: calc(100vh - 70px);
    /* trừ chiều cao footer */
    border: none;
}

.loading-message {
    height: calc(100vh - 70px);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
}

.file-info {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #fff;
    border-top: 1px solid #ddd;
    height: 70px;
}

.info-text {
    display: flex;
    flex-direction: column;
}

.file-name {
    font-weight: bold;
    color: #222;
}

.file-meta {
    font-size: 13px;
    color: #666;
}

.download-btn {
    background: none;
    border: none;
    font-size: 22px;
    cursor: pointer;
    color: #1a73e8;
    margin-left: 16px;
}

.file-avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid #e0e0e0;
}

.file-meta .author {
    font-weight: 500;
    color: #222;
}

.file-meta {
    font-size: 13px;
    color: #666;
    margin-top: 2px;
}
</style>
